import {makeStyles, Theme} from '@material-ui/core';
import cx from 'classnames';
import React, {FunctionComponent, memo} from 'react';
import {
  createLunResizedImageUrl,
  createResizedImageUrl,
  createSrcSet,
} from 'utils/media';

const SCREENS_DENSITIES = [1, 2];

export interface ResizedImageProps {
  imageKey: string;
  rounded?: boolean;
  round?: boolean;
  width: number;
  height: number;
  className?: string;
  alt?: string;
  densities?: number[];
  loading?: 'eager' | 'lazy';
  useLun?: boolean;
}

const useStyles = makeStyles<Theme, ResizedImageProps>(theme => ({
  root: {
    borderRadius: props => (props.round ? '50%' : (props.rounded ? theme.shape.borderRadius : 0)),
    width: props => props.width,
    height: props => props.height,
  },
}));

export const ResizedImage: FunctionComponent<ResizedImageProps> = memo(
  (props: ResizedImageProps) => {
    const {densities = [], imageKey, width, height, className, alt = '', useLun} = props;

    const classes = useStyles(props);

    const src = useLun
      ? createLunResizedImageUrl(imageKey, width, height)
      : createResizedImageUrl(imageKey, width, height);

    return (
      <img
    // @ts-ignore
        loading={props.loading || undefined}
        className={cx(classes.root, className)}
        src={src}
        srcSet={createSrcSet(
          ...(densities && densities.length ? densities : SCREENS_DENSITIES).map(density =>
            useLun
              ? createLunResizedImageUrl(imageKey, width * density, height * density)
              : createResizedImageUrl(imageKey, width * density, height * density)
          )
        )}
        alt={alt}
      />
    );
  }
);
